import { createAction } from 'redux-actions';

export const userDocumentFetch = createAction('USER_DASHBOARD_USER_DOCUMENT_FETCH');
export const userDocumentSet = createAction('USER_DASHBOARD_USER_DOCUMENT_SET');
